const Paginator = require("./legal_list_paginator");
$(document).ready(function () {
    // Initialise the ArticlePaginator for each paginator in the page. The first
    // paginator takes priority for handling SEO and push state.
    $('[data-paginator="legal-list"]').each((i, el) => {
        const paginator = new Paginator(el, {
            disableSEO: true,
            disableURL: true,
        });
        paginator.rebuild();
    });
});
